import dayjs from 'dayjs';

import { StreamerWheelForm, StreamerWheelMetadataEntry } from './form';

import { SelectOption } from 'v2/types';
import { StreamerWheelMetadata, StreamerWheelModel, StreamerWheelType } from 'v2/types/StreamerWheelModel';

export const streamerWheelTypeToLabel: Record<StreamerWheelType, string> = {
  [StreamerWheelType.LOTTERY]: 'Lottery',
  [StreamerWheelType.WHEEL]: 'Wheel',
};

export const STREAMER_WHEEL_SELECT_OPTIONS: SelectOption<StreamerWheelType>[] = [
  {
    id: StreamerWheelType.LOTTERY,
    value: StreamerWheelType.LOTTERY,
    label: streamerWheelTypeToLabel[StreamerWheelType.LOTTERY],
  },
  {
    id: StreamerWheelType.WHEEL,
    value: StreamerWheelType.WHEEL,
    label: streamerWheelTypeToLabel[StreamerWheelType.WHEEL],
  },
];

export function mapDtoToForm(dto: StreamerWheelModel): StreamerWheelForm {
  const metadata: StreamerWheelMetadataEntry[] = dto.metadata
    ? Object.entries(dto.metadata).map(([key, value]) => ({ key, value }))
    : [];

  return {
    type: dto.type,
    name: dto.name ?? '',
    image390Id: dto.image390Id ?? '',
    link: dto.link ?? '',
    bonus: dto.bonus ?? '',
    description: dto.description ?? '',
    endDate: dto.endDate ? dayjs(dto.endDate) : null,
    isActive: dto.isActive ?? false,
    metadata,
  };
}

export function mapFormToDto(form: StreamerWheelForm): Omit<StreamerWheelModel, 'id'> {
  const metadata: StreamerWheelMetadata = form.metadata.reduce<StreamerWheelMetadata>((acc, entry) => {
    const key = entry.key.trim();
    const value = entry.value.trim();

    if (key.length > 0 && value.length > 0) {
      acc[key] = value;
    }

    return acc;
  }, {});

  return {
    type: form.type,
    name: form.name.trim(),
    image390Id: form.image390Id,
    link: form.link.trim(),
    bonus: form.bonus,
    description: form.description.trim(),
    metadata,
    isActive: form.isActive,
    ...(form.endDate ? { endDate: form.endDate.startOf('minute').format() } : {}),
  };
}
